var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyboard"},_vm._l((_vm.keys),function(item,index){return _c('div',{key:item[0],class:['keyboard__item', _vm.getKeyClassName(item[1], index)],on:{"click":function($event){return _vm.tapKey(item[1], index)}}},[(item[1] === 'backspace')?_c('i',{staticClass:"backspace-icon"}):_c('span',[_vm._v(_vm._s(item[0]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }